<template>
  <log-quick-submit
    v-model="comment"
    class="relative"
    :placeholder="$t('ACTIVITY.COMMENTS.COMMENT_PLACEHOLDER')"
    :return-placeholder="$t('ACTIVITY.COMMENTS.RETURN_PLACEHOLDER')"
    :loading="isPending"
    :is-sms="!!smsId"
    @submit="submitComment"
  >
    <template v-if="!smsId" #actionBar>
      <avatar-with-name
        :user="currentUser || {}"
        data-cy="log-comment-author"
      />
    </template>
  </log-quick-submit>
</template>

<script lang="ts">
import { inject, ref } from "vue";

import { LOG_UPDATED } from "@/helpers/constants/events";
import { CommunicationLogContextKey } from "@/helpers/symbols";
import { useAuth } from "@/hooks/auth";
import { useEmitter } from "@/hooks/common";
import { useCreateCommentMutation } from "@/hooks/queries/useInbox";

import LogQuickSubmit from "@/components/communicationLogs/forms/LogQuickSubmit.vue";
import AvatarWithName from "@/components/ui/AvatarWithName.vue";
</script>

<script setup lang="ts">
const { logId, smsId } = defineProps<{
  logId?: number;
  smsId?: number | null;
}>();
const { currentUser } = useAuth();

const context = inject(CommunicationLogContextKey, {
  type: null,
  logId: null,
});

const comment = ref("");

const { mutateAsync, isPending } = useCreateCommentMutation(smsId);
const emitter = useEmitter();

const submitComment = async () => {
  if (!comment.value || !context.type || (!context.logId && !logId)) {
    return;
  }
  await mutateAsync({
    comment: comment.value,
    type: context.type,
    logId: (logId ?? context.logId) as number,
  });
  comment.value = "";
  emitter.emit(LOG_UPDATED);
};
</script>
